module.exports = __webpack_public_path__ + "static/media/Leta Lestrange 1.4bf0b706.jpg";